module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_cat04-5aa0fd8079cb65e79966fe438d6cfdad.svg";